import React from 'react';

const OrderProductsSummary = ({ order, showDetailed = false }) => {
  if (!order) return null;

  const getGroupedItemsSummary = () => {
    if ((!order.items || order.items.length === 0) && (!order.specialProducts || order.specialProducts.length === 0)) {
      return 'Sin productos';
    }
  
    const typeMap = {};
    
    // Procesar productos normales
    if (order.items && order.items.length > 0) {
      order.items.forEach(item => {
        const typeName = item.productPrice?.type?.typeName || 'Sin tipo';
        if (!typeMap[typeName]) {
          typeMap[typeName] = 0;
        }
        typeMap[typeName] += item.quantity;
      });
    }
    
    // Procesar productos especiales
    if (order.specialProducts && order.specialProducts.length > 0) {
      order.specialProducts.forEach(item => {
        const typeName = item.productType?.typeName || 'Especial';
        if (!typeMap[typeName]) typeMap[typeName] = 0;
        typeMap[typeName] += (item.quantity || 1);
      });
    }
  
    return Object.entries(typeMap)
      .map(([type, qty]) => `${qty}x ${type}`)
      .join(', ');
  };

  const getProductsStats = () => {
    const totalItems = (order.items?.length || 0) + (order.specialProducts?.length || 0);
    const totalQuantity = (order.items || []).reduce((acc, item) => acc + item.quantity, 0) + 
                         (order.specialProducts || []).reduce((acc, item) => acc + (item.quantity || 1), 0);
    
    return {
      totalItems,
      totalQuantity,
      label: totalItems > 0 ? `${totalQuantity} ${totalQuantity > 1 ? 'Artículos' : 'Artículo'}` : 'Sin productos'
    };
  };

  const stats = getProductsStats();

  if (showDetailed) {
    return (
      <div className="order-products-summary">
        <div className="d-flex align-items-center gap-2 mb-2">
          <span>📦</span>
          <strong>{stats.label}</strong>
        </div>
        <div className="text-muted small">
          {getGroupedItemsSummary()}
        </div>
      </div>
    );
  }

  return (
    <div className="d-flex align-items-center gap-1 text-muted small">
      <span>📦</span>
      <span>{getGroupedItemsSummary()}</span>
    </div>
  );
};

export default OrderProductsSummary;